<template>
  <div>
    <b-card>
      <div slot="header">
        <div class="row d-flex">
          <strong size="md">Retrait de commande entre le&nbsp;</strong>
          <datepicker v-model="rangeStart" format="dd/MM/yyyy" :monday-first=true required language="fr">
          </datepicker>
          <strong>&nbsp;et le&nbsp;</strong>
          <datepicker v-model="rangeEnd" format="dd/MM/yyyy" :monday-first=true required language="fr">
          </datepicker>
        </div>
        <div class="row mt-1">
          <b-button class="col-md-1" v-b-toggle.advanced variant="link">{{ plustext }}</b-button>
          <b-collapse id="advanced" v-model="advancedSearch" class="col-md-12">
            <div class="row mt-2">
              <strong class="col-md-3">Prise de commande entre le&nbsp;</strong>
              <datepicker v-model="orderRangeStart" format="dd/MM/yyyy" :monday-first=true required language="fr" :bootstrapStyling=true>
              </datepicker>
              <b-form-input class="col-md-2" type="time" size="sm" v-model="orderHourStart"></b-form-input>
              <strong>&nbsp;et le&nbsp;</strong>
              <datepicker v-model="orderRangeEnd" format="dd/MM/yyyy" :monday-first=true required language="fr" :bootstrapStyling=true>
              </datepicker>
              <b-form-input class="col-md-2" type="time" size="sm" v-model="orderHourEnd"></b-form-input>
            </div>
            <div class="row mt-2">
              <b-form-checkbox id="cumul" v-model="cumulEnabled">
                Faire un cumul de production par référence sur la période
              </b-form-checkbox>
            </div>
          </b-collapse>
        </div>
        <div class="clearfix">
          <div class="float-left">Etat au {{ serverDate }}
          </div>
          <b-btn class="float-right" size="sm" variant="outline-success" v-on:click="printOrders">
            Imprimer
          </b-btn>
        </div>
      </div><!-- header -->
      <div v-if="cumulEnabled">
        <div>
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th style="width: 200px;">Ref</th>
                <th >Intitulé</th>
                <th style="width: 200px;">Qté</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="ref in Object.keys(totalPerRefs)">
                <template v-for="container in Object.keys(totalPerRefs[ref])">
                  <tr v-for="u in Object.keys(totalPerRefs[ref][container])">
                    <td>{{ ref }}</td><td>{{ totalPerRefs[ref][container][u].desc }} ({{ container }})</td><td>{{ totalPerRefs[ref][container][u].qty }} {{ u }}</td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else>
        <ul>
          <li is="order-row" v-for="order in orders" v-bind:order="order"></li>
        </ul>
      </div>
    </b-card>
    <!-- modal to display error -->
    <b-modal size="lg" ok-only v-model="showModalError">
      <span v-html="lastError"></span>
    </b-modal>
  </div><!-- whole page -->
</template>

<script>
import store from '@/store'
import router from '@/router'
// import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'

var singleOrderRow = {
  template: '<tr><td>{{ item.ref }}</td><td>{{ item.name }}&nbsp;({{ item.container }})</td><td>{{ item.qty }} {{ item.unite }}</td></tr>',
  props: ['item']
}

var orderRow = {
  components: {
    'order-detailled-row': singleOrderRow
  },
  // template: '<tr><td>{{ order.date }}</td><td colspan="3"><table><tbody><tr is="order-detailled-row" v-for="item in order.items"></tr></tbody></table></td></tr>',
  template: '<li><p class="col-md-12">{{ order.date }}</p>' +
  '<table class="table table-bordered table-striped table-sm">' +
  '<thead>' +
  '<tr>' +
  '<th style="width: 200px;">Ref</th>' +
  '<th >Intitulé</th>' +
  '<th style="width: 200px;">Qté</th>' +
  '</tr>' +
  '</thead>' +
  '<tbody>' +
  '<tr is="order-detailled-row" v-for="item in order.items" v-bind:key="order.id" v-bind:item="item"></tr>' +
  '</tbody>' +
  '</table>' +
  '</li>',
  props: ['order']
}

export default {
  name: 'listing',
  components: {
    'order-row': orderRow,
    datepicker: Datepicker
  },
  data: function () {
    return {
      plustext: 'Plus >>',
      consoleOutput: false, // debug
      orders: [], // commandes à produire
      totalPerRefs: [], // total des commandes par refs
      showModalError: false,
      lastError: '',
      date: '',
      opened: [],
      displayDetailsModal: false,
      displaySpinner: true,
      detailRef: '',
      orderRangeStart: new Date(),
      orderRangeEnd: new Date(),
      rangeStart: new Date(),
      rangeEnd: new Date(),
      serverDate: '',
      orderHourStart: '',
      orderHourEnd: '',
      advancedSearch: false, // display "plus" panel
      cumulEnabled: false, // set total per ref,
      readyForPrinting: false,
      src: ''
    }
  },
  beforeCreate () {
    if (!store.state.isLogged) {
      router.push('/')
    }
  },
  created () {
    // debug
    // this.rangeStart.setDate(this.rangeStart.getDate() - 40)
    // this.rangeEnd.setDate(this.rangeStart.getDate() + 100)
    // debug end
    this.rangeEnd.setDate(this.rangeStart.getDate() + 7)
    this.orderHourEnd = this.rangeStart.getHours() + ':' + this.rangeStart.getMinutes()
    // this.fetchOrders()
  },
  watch: {
    orderRangeStart: {
      handler: function () {
        this.onRangeModified()
      }
    },
    orderRangeEnd: {
      handler: function () {
        this.onRangeModified()
      }
    },
    rangeStart: {
      handler: function () {
        this.onRangeModified()
      }
    },
    rangeEnd: {
      handler: function () {
        this.onRangeModified()
      }
    },
    orderHourStart: {
      handler: function () {
        this.onRangeModified()
      }
    },
    orderHourEnd: {
      handler: function () {
        this.onRangeModified()
      }
    },
    advancedSearch: {
      handler: function () {
        if (!this.advancedSearch) {
          this.plustext = 'Plus >>'
        } else {
          this.plustext = 'Moins <<'
        }
        this.onRangeModified()
      }
    }
  },
  methods: {
    onRangeModified () {
      // reget data
      this.fetchOrders()
    },
    fetchOrders () {
      this.$Progress.start()
      var req = {from: this.rangeStart.toJSON(), to: this.rangeEnd.toJSON()}
      if (this.advancedSearch && this.orderHourStart !== '') {
        req.orderRangeStart = this.orderRangeStart.toJSON()
        req.orderRangeEnd = this.orderRangeEnd.toJSON()
        req.orderHourStart = this.orderHourStart
        req.orderHourEnd = this.orderHourEnd
      }
      this.orders = []
      this.$http.get(process.env.API_URL + '/orders/get-by-product', {params: req}).then((response) => {
        var orderList = response.body.list
        this.serverDate = response.body.date
        if (this.consoleOutput) {
          console.log('got ' + Object.keys(orderList).length)
        }
        var dates = Object.keys(orderList)
        var totalRefs = []
        for (var d in dates) {
          var fullre = dates[d]
          // var orderDate = fullre.match(/-(.*)$/)
          // var order = {date: orderDate[1], items: []}
          var order = {date: fullre, items: []}
          if (this.consoleOutput) {
            console.log('date: ' + order.date)
          }
          var refs = Object.keys(orderList[fullre])
          for (var r in refs) {
            if (this.consoleOutput) {
              console.log('ref: ' + r)
            }
            for (var container in orderList[fullre][refs[r]].quantity) {
              if (this.consoleOutput) {
                console.log('container: ' + container)
              }
              for (var u in orderList[fullre][refs[r]].quantity[container]) {
                if (this.consoleOutput) {
                  console.log('unite: ' + u)
                }
                var localRef = {ref: refs[r], name: orderList[fullre][refs[r]].name, qty: orderList[fullre][refs[r]].quantity[container][u], container: container, unite: u}
                if (this.consoleOutput) {
                  console.log(localRef.ref + ': ' + localRef.qty + ' items (' + localRef.name + '), container: ' + container + ', unite: ' + u)
                }
                order.items.push(localRef)
                if (typeof totalRefs[refs[r]] === 'undefined') {
                  totalRefs[refs[r]] = []
                }
                if (typeof totalRefs[refs[r]][container] === 'undefined') {
                  totalRefs[refs[r]][container] = []
                }
                if (typeof totalRefs[refs[r]][container][u] === 'undefined') {
                  totalRefs[refs[r]][container][u] = {qty: 0, desc: localRef.name}
                }
                totalRefs[refs[r]][container][u].qty += localRef.qty
                console.log('qty total for ' + refs[r] + '/' + container + ' is now: ' + totalRefs[refs[r]][container][u].qty)
              }
            }
          }
          this.orders.push(order)
        }
        this.totalPerRefs = []
        this.totalPerRefs = totalRefs
        this.$Progress.finish()
      },
      (error) => {
        this.$Progress.fail()
        this.orders = []
        this.totalPerRefs = []
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        }
      })
      this.$Progress.start()
      // get pdf
      req.format = 'pdf'
      this.$http.get(process.env.API_URL + '/orders/get-by-product', {params: req, responseType: 'arraybuffer'}).then((response) => {
        var base64EncodedPDF = response.body
        this.src_normal = base64EncodedPDF
        this.$Progress.finish()
      },
      (error) => {
        console.log(error)
        this.$Progress.fail()
      })
      this.$Progress.start()
      // get pdf
      req.format = 'pdf'
      req.cumul = 1
      this.$http.get(process.env.API_URL + '/orders/get-by-product', {params: req, responseType: 'arraybuffer'}).then((response) => {
        var base64EncodedPDF = response.body
        this.src_cumul = base64EncodedPDF
        this.readyForPrinting = true
        this.$Progress.finish()
      },
      (error) => {
        console.log(error)
        this.$Progress.fail()
      })
    },
    printOrders () {
      if (this.consoleOutput) {
        console.log('print orders')
      }
      var base64EncodedPDF = ''
      if (this.cumulEnabled) {
        base64EncodedPDF = this.src_cumul
      } else {
        base64EncodedPDF = this.src_normal
      }
      var downloadLink = document.createElement('a')
      // downloadLink.target = '_blank'
      downloadLink.download = 'production.pdf'
      // convert downloaded data to a Blob
      var blob = new Blob([base64EncodedPDF], {type: 'application/pdf'})
      // create an object URL from the Blob
      var URL = window.URL || window.webkitURL
      var downloadUrl = URL.createObjectURL(blob)
      // set object URL as the anchor's href
      downloadLink.href = downloadUrl
      // append the anchor to document body
      document.body.append(downloadLink)
      // fire a click event on the anchor
      downloadLink.click()
      // cleanup: remove element and revoke object URL
      document.body.removeChild(downloadLink)
      URL.revokeObjectURL(downloadUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Production.vue?d5508f68